import { render, staticRenderFns } from "./buildingManageList.vue?vue&type=template&id=dc31fc98&scoped=true"
import script from "./buildingManageList.vue?vue&type=script&lang=js"
export * from "./buildingManageList.vue?vue&type=script&lang=js"
import style0 from "./buildingManageList.vue?vue&type=style&index=0&id=dc31fc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc31fc98",
  null
  
)

export default component.exports